import React from 'react';
import { useDispatch } from 'react-redux';
import { Grid, IconButton, ListItemSecondaryAction, ListItemText, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { ButtonLink, Icon, showDeleteDialog, Text, useSettings } from 'app/main/components';

export default function GroupsVisibilityListItem(props: ItemLayoutProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();

	const button = (
		<ListItemSecondaryAction className="relative right-0 top-0 transform-none self-center">
			<Tooltip title={t('VIEW_ITEM_BUTTON_REMOVE')} arrow>
				<IconButton
					onClick={() =>
						dispatch(
							showDeleteDialog({
								module: props.settings.modu_title,
								id: props.model[`${props.settings.modu_short}_id`],
								title: props.model.grps_title,
								hardDelete: true,
								replace: false,
								updateRefresh: props.buttonProps.updateRefresh
							})
						)
					}
				>
					<Icon icon="delete" />
				</IconButton>
			</Tooltip>
		</ListItemSecondaryAction>
	);

	return (
		<GridListItem secondaryAction={button}>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid size={{ xs: props.width >= 600 ? 6 : 12 }}>
					<Grid container>
						<Grid size={12} className="inline-flex items-center">
							{/* WARNING */}
							{props.model.grps_warning_desc && (
								<Tooltip title={props.model.grps_warning_desc} arrow>
									<Icon className="mr-2" icon="alert-circle-outline" color="warning.main" />
								</Tooltip>
							)}
							{/* BLOCKED */}
							{props.model.grps_blocked_desc && (
								<Tooltip title={props.model.grps_blocked_desc} arrow>
									<Icon className="mr-2" icon="block" color="error.main" />
								</Tooltip>
							)}
							{/* TITLE */}
							<Text
								className="font-600"
								variant="subtitle2"
								to={{ module: 'groups', uid: props.model.grps_uid }}
							>
								{props.model.grps_title}
							</Text>
						</Grid>
						<Grid>
							{/* MANAGER */}
							<ButtonLink
								href={`/users/${props.model.user_manager_uid}`}
								icon="account-tie"
								fallback={t('VIEW_ITEM_NO_INTREF')}
							>
								{props.model.user_manager_title}
							</ButtonLink>
						</Grid>
					</Grid>
				</Grid>
				{/* {props.width >= 600 && <Grid item xs={props.width >= 600 ? 6 : 12}></Grid>} */}
			</Grid>
		</GridListItem>
	);
}
